import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LogoBlack from "../assets/img/MOSIDA-black.png";
import ShopNoticeModal from "../shop/ShopNoticeModal";
import ShopStage from "../shop/ShopStage";
import {
  clearPendingPaymentOrder,
  readPendingOrderNumbers,
} from "../shop/pendingPaymentOrder";
import { clearKioskSession } from "../utils/kioskSession";
import "../shop/shop.css";
import "../shop/shopKiosk.css";

const LOGOUT_AFTER_MS = 10000;
const LOGOUT_NOTICE_MS = 3000;

function CounterPayment() {
  const navigate = useNavigate();
  const location = useLocation();
  const [logoutNoticeOpen, setLogoutNoticeOpen] = useState(false);

  const orderNumbers = useMemo(() => {
    const state = location.state || {};
    if (Array.isArray(state.orderNumbers) && state.orderNumbers.length > 0) {
      return state.orderNumbers.map((value) => String(value).trim()).filter(Boolean);
    }
    if (state.orderNumber != null && String(state.orderNumber).trim()) {
      return [String(state.orderNumber).trim()];
    }
    return readPendingOrderNumbers();
  }, [location.state]);

  const hasMultiple = orderNumbers.length > 1;

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setLogoutNoticeOpen(true);
    }, LOGOUT_AFTER_MS);
    return () => window.clearTimeout(timer);
  }, []);

  const finishLogout = () => {
    setLogoutNoticeOpen(false);
    clearPendingPaymentOrder();
    clearKioskSession();
    navigate("/", { replace: true, state: { sessionResetAt: Date.now() } });
  };

  return (
    <ShopStage>
      <div className="shopScreen paymentSuccess paymentSuccess--studio">
        <div className="paymentSuccess__copy">
          <img
            src={LogoBlack}
            alt="MOSIDA"
            className="paymentSuccess__logo"
            style={{ maxWidth: 160, marginBottom: 40 }}
          />
          <h1 className="paymentSuccess__title">
            {hasMultiple ? (
              <>
                Your orders have been placed successfully
              </>
            ) : (
              <>
                Your order has been placed successfully
              </>
            )}
          </h1>
          {orderNumbers.length > 0 ? (
            <div className="paymentSuccess__orders">
              {orderNumbers.map((number) => (
                <p className="paymentSuccess__order" key={number}>
                  ORDER #{number}
                </p>
              ))}
            </div>
          ) : null}
          <div className="paymentSuccess__claimRow mt-4">
            <p className="paymentSuccess__claim">Please claim your print at</p>
            <span className="paymentSuccess__badge">MOSIDA ART CENTER</span>
          </div>
        </div>

        <ShopNoticeModal
          show={logoutNoticeOpen}
          variant="cart"
          duration={LOGOUT_NOTICE_MS}
          dismissible={false}
          message="LOGOUT SUCCESSFULLY!"
          onHide={finishLogout}
        />
      </div>
    </ShopStage>
  );
}

export default CounterPayment;
